<div class="row content__grid">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box">
      <div class="row align-items-center">
        <div class="col-sm-6 col-md-6 col-sm-6 col-6">
          <h4 class="page-title content__title">Lista reservas</h4>
        </div>
        <div class="col-sm-6 col-sm-6 col-md-6 col-sm-6 col-6 content__boxBtnHead">
          <ng-container>
            <a routerLink="/{{branchofficeSlug}}/reservas/reserva/nuevo" class="btn btn-primary">
              <i class="fa fa-plus m-r-5"></i> Crear reserva </a>
          </ng-container>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12 col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="card content__grid__card">
      <div class="card-body content__grid__cardbody">
        <div class="content__subhead">
          <div class="row">
            <div class="col-lg-7 col-md-7 col-sm-6 col-12 content__subhead__boxBtns">
              <button type="button" class="btn btn-light waves-effect" title="Actualizar" (click)="refresh()">
                <i class="fas fa-undo"></i></button>
              <div class="content__subhead__inputGrid">
                <div class="input-group" style="width: 105%;">
                  <span class="input-group-prepend">
                    <span class="input-group-text content__subhead__inputGrid__title">
                      <i class="far fa-calendar-alt"></i>
                    </span>
                  </span>
                  <input type="text" id="date_range" class="form-control content__subhead__inputGrid__input">
                </div>
              </div>
            </div>
            <div class="col-lg-5 col-md-5 col-sm-6 col-12">
              <component-search (searchEvent)="search($event)"></component-search>
            </div>
          </div>
        </div>
        <div class="content__boxTble">
          <div class="table-responsive">
            <table class="table table-hover mb-0">
              <thead class="thead-default">
                <tr>
                  <th>N° reserva</th>
                  <th><span class="f-s-12">Etq./Grupo</span></th>
                  <th>Reponsable</th>
                  <th class="text-center">N°.pax</th>
                  <th>Teléfonos</th>
                  <!-- <th class="text-center">Sobre tours</th> -->
                  <th class="text-center">R.Usuario</th>
                  <th class="text-center">Estado</th>
                  <th class="text-center">Total</th>
                  <th class="text-center">Pagado</th>
                  <th class="text-center">Deuda</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngIf="items.length == 0">
                  <td colspan="2"><span>No se encontraron registros</span></td>
                </ng-container>
                <ng-container *ngIf="items.length > 0">
                  <tr class="f-s-12" [ngClass]="{'text-danger': item.is_checkout }"
                    *ngFor="let item of items | paginate: { itemsPerPage: dataPagination.pageSize, currentPage: dataPagination.currentPage, totalItems:dataPagination.totalItems }; let i = index">
                    <td>
                      <a class="grid__link nowrap" (click)="detail(item.id)">
                        <i *ngIf="item.is_favorite" class="fas fa-star m-r-2 color-favorite"></i>                        
                        {{item.code}}
                      </a>
                      <p class="bold f-s-10 m-b-0">
                        Reg: {{item.created_at | date: 'mediumDate'}}</p>
                      <p *ngIf="item.is_book_hotel" class="bold m-b-0 f-s-9">
                        <i class="fas fa-hotel m-r-5" style="color: black !important;"></i>
                        <span class="badge badge-hotel f-s-10">RES. SOLO HOTEL</span>
                      </p>
                    </td>
                    <td>
                      {{item.reference_voucher}}
                      <div *ngIf="item.workinggroup_id != null" style="margin-top: -4px;">
                        <span class="badge badge-dark f-s-8">{{item.workinggroup_data.description}}</span>                        
                      </div>
                    </td>
                    <td>
                      <p class="m-b-0" style="line-height: 1.3em;">{{item.client_data.fullname}}</p>
                      <p class="bold f-s-10 m-b-0">{{item.client_data.typeDocument}} : {{item.client_data.document}}</p>
                    </td>
                    <td class="text-center">
                      {{item.nro_pax}}
                    </td>
                    <td>
                      <div>{{item.client_data.cellphone}}</div>
                      <div *ngIf="item.client_data.telephone != null">
                        {{item.client_data.telephone}}
                      </div>
                    </td>
                    <!-- <td class="text-center">
                      <ng-container *ngIf="!item.is_book_hotel">
                        <span *ngIf="item.pending_tours > 0" class="badge badge-info f-s-10">Por realizar
                          {{item.pending_tours}} tours</span>
                        <span *ngIf="item.pending_tours == 0" class="badge badge-orange f-s-10"><i
                            class="fas fa-check m-r-2"></i> COMPLETADOS</span>
                      </ng-container>
                      <ng-container *ngIf="item.is_book_hotel">
                        <span>-</span>
                      </ng-container>
                    </td> -->
                    <td class="text-center text-uppercase" style="color: #6f6b6b;">
                      {{item.user_data.username}}
                    </td>
                    <td class="text-center">
                      <span *ngIf="item.is_checkout" class="badge badge-danger f-s-10">Anulado</span>
                      <span *ngIf="!item.is_checkout"
                        class="badge f-s-10 badge-{{item.status_booking.class}}">{{item.status_booking.message}}</span>
                    </td>
                    <td class="text-center nowrap">
                      {{toolsService.momeySol()}}{{item.total}}
                    </td>
                    <td class="text-center nowrap">
                      <span class="text-primary">{{toolsService.momeySol()}}{{item.total_paid}}</span>
                    </td>
                    <td>
                      <span class="text-danger nowrap bold">
                        {{toolsService.momeySol()}}{{(item.total - item.total_paid).toFixed(2)}}
                      </span>
                    </td>
                    <td class="text-center">
                      <ng-container *ngIf="!item.is_checkout">
                        <a class="btn p-5 pointer text-success bold" (click)="edit(item.id)">
                          <i class="fas fa-pencil-alt"></i>
                        </a>
                      </ng-container>
                      <!-- <div class="btn-group mo-mb-2" ng-if="data.is_checkout == false">
                        <button class="btn btn-light btn-dots btn-sm dropdown-toggle" type="button"
                          data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                          <i class="fas fa-ellipsis-h"></i>
                        </button>
                        <div class="dropdown-menu" x-placement="bottom-start">
                          <a class="dropdown-item pointer" (click)="edit(item.id)">
                            <i class="fas fa-pencil-alt m-r-5 text-success"></i> Editar
                          </a>
                        </div>
                      </div> -->
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-12 ">
          <div class="row content_pagination">
            <div class="col-lg-4">
              <p class="pagination__label">Total <span class="bold">{{dataPagination.totalItems}}</span> registros.</p>
            </div>
            <div class="text-right col-lg-8">
              <ng-container *ngIf="items.length > 0">
                <app-pagination (paginateEvent)="handlePageChange($event)"></app-pagination>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


</div>
